import React from 'react';

import PropTypes from 'prop-types';

import Avatar from './Avatar';

const MAX_AVATARS = 3;

const OverflowAvatar = ({ count }) => (
  // TODO: Confirm that all Tailwind classes are correct.
  <div className="bg-gray-200 border-white border-1 flex h-6 items-center justify-center rounded-full w-6">
    <span className="text-gray-600 text-xs">+{count}</span>
  </div>
);

OverflowAvatar.propTypes = {
  count: PropTypes.number.isRequired,
};

const AvatarList = ({ people }) => {
  const visiblePeople = people.slice(0, MAX_AVATARS);
  const remainingCount = people.length - MAX_AVATARS;
  const displayOverflowAvatar = remainingCount > 0;

  return (
    <div className="flex -space-x-1">
      {visiblePeople.map(({ avatarColor, initials, id }) => (
        <Avatar backgroundColor={avatarColor} initials={initials} key={id} size="sm" />
      ))}

      {displayOverflowAvatar && <OverflowAvatar count={remainingCount} />}
    </div>
  );
};

const personShape = PropTypes.shape({
  avatarColor: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  initials: PropTypes.string.isRequired,
});

AvatarList.propTypes = {
  people: PropTypes.arrayOf(personShape).isRequired,
};

export default AvatarList;
